import { YourPoints } from './YourPoints'
import { Boosts } from './Boosts'

export function PointsInfoContainer() {
  return (
    <div className="flex flex-col gap-4 sm:flex-row">
      <YourPoints />
      <Boosts />
    </div>
  )
}
